module.exports = __webpack_public_path__ + "img/cancun-mar.63d75093.jpg";